import React from "react";
import "./style.css";
import Button from "../../component/Button/Button";
import { useNavigate } from "react-router-dom";
const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="notfound">
      <div className="container-1440">
        <span>
          <img src={require("../../Assets/img/logo.png")} alt="" />
        </span>
        <div className="logo"></div>
        <h1>Ooops...</h1>
        <h2>Something went wrong</h2>
        {/* <span className="ball1">
          <img src={require("../../Assets/img/ball1.png")} />
        </span>
        <span  className="ball2">
          <img src={require("../../Assets/img/ball2.png")} />
        </span> */}
        {/* <span >
          <img src={require("../../Assets/img/screen.png")} />
        </span> */}
        <div className="screenImg">
          <img src={require("../../Assets/img/page-not-found.png")} alt="" />
        </div>
        {/* <span  className="ball3">
          <img src={require("../../Assets/img/ball3.png")} />
        </span>
        <span  className="ball4">
          <img src={require("../../Assets/img/ball4.png")} />
        </span> */}
        <div className="para">
          <p>We searched for it all over..</p>
          <p> looking for somewhere else..or it just never existed!</p>
        </div>

        {/* <button className="nav-linkn">Go to Homepage</button> */}
        <Button onClick={() => navigate("/")} value="Go To Homepage"></Button>
      </div>
    </div>
  );
};

export default NotFound;
